import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
export interface Pack {
  id: string;
  name: string;
  price: string;
  emoji: string;
  descriptor: string;
  url: string;
}
export const packs: Pack[] = [{
  id: 'inicial',
  name: 'PACK INICIAL',
  price: '$19.990',
  emoji: '🟡',
  descriptor: 'Las 8 guías completas',
  url: 'https://checkout.saberclick.com/cart/50291241517249:1'
}, {
  id: 'pro',
  name: 'PACK PRO',
  price: '$24.990',
  emoji: '🔵',
  descriptor: '8 guías + Bonos 1 y 2',
  url: 'https://checkout.saberclick.com/cart/50294106947777:1'
}, {
  id: 'full',
  name: 'PACK FULL ACCESS',
  price: '$29.990',
  emoji: '🏆',
  descriptor: '8 guías + los 8 bonos completos',
  url: 'https://checkout.saberclick.com/cart/50291255935169:1'
}];
export function PackSelector() {
  // Highest-price option (Full Access) preselected by default.
  const [selectedId, setSelectedId] = useState<string>('full');
  const selected = packs.find(p => p.id === selectedId) ?? packs[2];
  const handlePurchase = () => {
    window.location.href = selected.url;
  };
  return <div className="max-w-2xl mx-auto" data-id="element-170">
      <div role="radiogroup" aria-label="Elegí tu pack" className="space-y-3" data-id="element-171">
        {packs.map(pack => {
        const isSelected = pack.id === selectedId;
        const isFull = pack.id === 'full';
        return <motion.button key={pack.id} type="button" role="radio" aria-checked={isSelected} onClick={() => setSelectedId(pack.id)} whileTap={{
          scale: 0.99
        }} className={`relative w-full text-left rounded-xl border p-3 sm:p-4 flex items-center gap-3 sm:gap-4 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gold/50 ${isSelected ? isFull ? 'border-gold bg-gold/10 shadow-[0_0_24px_rgba(212,175,55,0.25)]' : 'border-gold bg-gold/10 shadow-[0_0_18px_rgba(212,175,55,0.18)]' : 'border-gold/20 bg-violet-deep/60 hover:border-gold/40'}`} data-id="element-172">
              {/* Radio indicator */}
              <span className={`flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-gold bg-gold' : 'border-violet-100/40'}`} data-id="element-173">
                {isSelected && <Check className="w-3 h-3 sm:w-4 sm:h-4 text-violet-deep" data-id="element-174" />}
              </span>

              <span className="text-xl sm:text-2xl flex-shrink-0" data-id="element-175">
                {pack.emoji}
              </span>

              <span className="flex-1 min-w-0" data-id="element-176">
                <span className="flex items-center gap-2 flex-wrap" data-id="element-177">
                  <span className="font-display font-bold text-white text-sm sm:text-base" data-id="element-178">
                    {pack.name}
                  </span>
                  {isFull && <span className="bg-gold text-violet-deep text-[9px] sm:text-[10px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-179">
                      ⭐ MÁS ELEGIDA
                    </span>}
                </span>
                <span className="block text-[10px] sm:text-xs text-violet-100/60 truncate" data-id="element-180">
                  {pack.descriptor}
                </span>
              </span>

              <span className="font-display text-lg sm:text-2xl font-bold text-gold flex-shrink-0" data-id="element-181">
                {pack.price}
              </span>
            </motion.button>;
      })}
      </div>

      <motion.button type="button" onClick={handlePurchase} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.97
    }} className="w-full mt-5 bg-green hover:bg-green/90 text-white font-bold text-base sm:text-lg py-4 sm:py-5 rounded-xl shadow-lg hover:shadow-xl transition-colors duration-300" data-id="element-182">
        💥 COMPRAR {selected.name} — {selected.price}
      </motion.button>
    </div>;
}